import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import { useTranslation } from 'react-i18next';

interface Props {
    message: string;
    onRetry: () => void;
    isFetching: boolean;
}

function GiftLoadError({ message, onRetry, isFetching }: Props) {
    const { t } = useTranslation('gift');
    return (
        <Column fullWidth spacing={3} align='center' role='alert'>
            <Text align='center'>{message}</Text>
            <Button type='button' disabled={isFetching} onClick={onRetry}>{t('home.retry')}</Button>
        </Column>
    );
}

export default GiftLoadError;
